import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useAppSettings } from "../contexts/AppSettingsContext";
import { toast } from "react-toastify";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { appName, appIcon } = useAppSettings();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Username dan password wajib diisi");
      return;
    }
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Login berhasil!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #fdf2f8 0%, #fce7f3 50%, #fbcfe8 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      {/* decorative blobs */}
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          top: "-80px",
          right: "-80px",
          width: 280,
          height: 280,
          borderRadius: "50%",
          background: "radial-gradient(circle, #f9a8d4 0%, transparent 70%)",
          opacity: 0.5,
          pointerEvents: "none",
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          bottom: "-60px",
          left: "-60px",
          width: 220,
          height: 220,
          borderRadius: "50%",
          background: "radial-gradient(circle, #f472b6 0%, transparent 70%)",
          opacity: 0.35,
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 24,
          boxShadow:
            "0 20px 60px rgba(233,30,140,0.12), 0 4px 16px rgba(0,0,0,0.06)",
          overflow: "hidden",
        }}
      >
        {/* top accent bar */}
        <div
          style={{
            height: 5,
            background: "linear-gradient(90deg, #e91e8c, #f472b6, #e91e8c)",
          }}
        />

        <div style={{ padding: "36px 32px 28px" }}>
          {/* Logo & brand */}
          <div className="text-center mb-4">
            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: 20,
                background: "linear-gradient(135deg, #e91e8c, #f472b6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 14px",
                boxShadow: "0 8px 24px rgba(233,30,140,0.3)",
              }}
            >
              {appIcon ? (
                <img
                  src={appIcon}
                  alt="icon"
                  style={{ width: 46, height: 46, objectFit: "contain", borderRadius: 8 }}
                />
              ) : (
                <span style={{ fontSize: "2.2rem", lineHeight: 1 }}>👗</span>
              )}
            </div>
            <h4
              className="fw-bold mb-1"
              style={{ color: "#1e293b", letterSpacing: "-0.02em" }}
            >
              {appName}
            </h4>
            <p style={{ color: "#94a3b8", fontSize: "0.85rem", margin: 0 }}>
              Masuk ke sistem kasir
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label
                className="form-label fw-semibold"
                style={{ fontSize: "0.85rem", color: "#475569" }}
              >
                Username
              </label>
              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Masukkan username"
                autoFocus
                style={{
                  borderRadius: 10,
                  border: "1.5px solid #e2e8f0",
                  padding: "10px 14px",
                  fontSize: "0.95rem",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#e91e8c")}
                onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
              />
            </div>
            <div className="mb-4">
              <label
                className="form-label fw-semibold"
                style={{ fontSize: "0.85rem", color: "#475569" }}
              >
                Password
              </label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Masukkan password"
                style={{
                  borderRadius: 10,
                  border: "1.5px solid #e2e8f0",
                  padding: "10px 14px",
                  fontSize: "0.95rem",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#e91e8c")}
                onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: 10,
                border: "none",
                background: loading
                  ? "#f9a8d4"
                  : "linear-gradient(135deg, #e91e8c, #f472b6)",
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.95rem",
                cursor: loading ? "not-allowed" : "pointer",
                boxShadow: loading ? "none" : "0 4px 16px rgba(233,30,140,0.35)",
                transition: "all 0.2s",
              }}
            >
              {loading ? (
                <span>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  />
                  Masuk...
                </span>
              ) : (
                "Masuk"
              )}
            </button>
          </form>

          {/* Track shortcut */}
          <div
            style={{
              marginTop: 20,
              padding: "12px 16px",
              background: "#fdf2f8",
              border: "1.5px solid #fbcfe8",
              borderRadius: 12,
              textAlign: "center",
            }}
          >
            <Link
              to="/track"
              style={{
                color: "#e91e8c",
                textDecoration: "none",
                fontSize: "0.875rem",
                fontWeight: 600,
              }}
            >
              🔍 Cek status laundry tanpa login
            </Link>
          </div>
        </div>
      </div>

      <p
        style={{
          marginTop: 20,
          fontSize: "0.75rem",
          color: "#be185d",
          opacity: 0.6,
        }}
      >
        &copy; {new Date().getFullYear()} {appName}
      </p>
    </div>
  );
};

export default Login;

